import groq from 'groq'

import { mediaAsset } from '../../../projections/mediaAsset'
import { callToAction } from '../../../projections/callToAction.js'

export const header = groq`
    _type,
    title,
    subtitle,
    featuredInsight->{
        metadata{
            "slug": slug.current,
            title
        },
        articleSetup{
            date,
            "category": category->name,
            "categorySlug": category->slug.current
        },
        presentation{
            media[0]{...${mediaAsset()}}
        },
        "readTime": sections[1]{
            "time":round(length(pt::text(content)) / 5 / 180 ),
        }.time,
    },
    sideCta{
    "title": coalesce(
        title,
        *[_type == 'sharedContent'][0].articles.callToActionTitle,
    ),
    cta{...${callToAction()}},
    }
`
